import { css } from '@emotion/react';
import { motion, type MotionProps } from 'motion/react';
import type { CommonHTMLAttributes } from '@frontend/types';
import { WeaveThemeValues } from '../../../component-theme/theme-types';
import { mergeClasses } from '../../../helpers';
import { styles } from '../../../styles';
import { ModalStyles } from '../modal.styles';
import { useModalContext } from '../provider';

type ModalBackdropProps = {
  zIndex?: WeaveThemeValues['ZIndex'];
  omitOffset?: boolean;
  showBackdrop?: boolean;
  show?: boolean; // Added to control visibility
};

export const ModalBackdrop = ({
  className,
  onClick,
  zIndex,
  omitOffset,
  show = true,
  ...rest
}: CommonHTMLAttributes & ModalBackdropProps & MotionProps) => {
  const { loadingState } = useModalContext();
  const backdropStyles = ModalStyles.modalBackdropStyles;

  /**
   * NOTE: Needs an AnimatedPresence to be in it's component heirarchy.
   * Is done automatically in CenteredModal
   */
  return (
    <motion.div
      css={[backdropStyles, zIndex && { zIndex }, !omitOffset && ((theme) => styles.getAdjustedHeight(theme))]}
      className={mergeClasses('wv-modal-backdrop', className)}
      initial={{ opacity: 0 }}
      animate={{ opacity: show ? 1 : 0 }}
      exit={{ opacity: 0 }}
      {...rest}
      // prevent click to close while in a loading state
      onClick={
        loadingState?.show
          ? undefined
          : (e) => {
              e.stopPropagation();
              onClick?.(e);
            }
      }
    />
  );
};

export const TrayModalBackdrop = ({
  className,
  onClick,
  zIndex,
  omitOffset,
  showBackdrop = true,
  ...rest
}: CommonHTMLAttributes & MotionProps & ModalBackdropProps) => {
  const { loadingState } = useModalContext();
  const backdropStyles = ModalStyles.modalBackdropStyles;
  return (
    <motion.div
      css={[
        showBackdrop && backdropStyles,
        zIndex && { zIndex },
        !omitOffset && ((theme) => styles.getAdjustedHeight(theme)),
        !showBackdrop &&
          css`
            pointer-events: none;
          `, // Allows the background to be interactive
      ]}
      className={mergeClasses('wv-modal-backdrop', className)}
      {...rest}
      // prevent click to close while in a loading state
      onClick={
        loadingState?.show
          ? undefined
          : (e) => {
              e.stopPropagation();
              onClick?.(e);
            }
      }
    />
  );
};
